import { ng } from '@uirouter/angularjs/lib/angular';
import { StateService } from '@uirouter/core';
import * as angular from 'angular';
import * as moment from 'moment';
import { NotificationService } from '../../../../app.common/modules/common/services/notification.service';
import { ClassificationCategoriesService } from '../../../../app.retailer.common/modules/categories/classification-categories.service';
import { CategoriesSelectorService } from '../../categories/categoriesSelector.service';
import { CategoryListItem, CreateNfcExportRequest } from '../../core';
import { IRetailerRootScope } from '../../core/models';
import { NfcRetailerStickersService } from '../nfc-retailer-stickers.service';
import { IChoiceClassificationCategoriesOptions } from '../shared/select-product-category/select-product-category.component';

class NfcExport implements ng.IComponentController {
    static $inject = ['$rootScope', '$state', '$scope', '$translate', '$uibModal', 'categoriesSelectorService',
        'classificationCategoriesService', 'nfcRetailerStickersService', 'notificationService'];

    modalInstance: ng.ui.bootstrap.IModalServiceInstance = <any>this;
    isCategoryButtonDisabled: boolean = true;

    nfcStickerOptions = [
        { ID: 0, Title: this.$translate.instant('sticker_type_all') },
        { ID: 1, Title: this.$translate.instant('sticker_type_product') },
        { ID: 2, Title: this.$translate.instant('sticker_type_information_card') },
        { ID: 3, Title: this.$translate.instant('sticker_type_offer') },
        { ID: 4, Title: this.$translate.instant('sticker_type_checkin') + '/' + this.$translate.instant('sticker_type_checkout') }
    ];

    model = {
        dateFrom: <Date> new Date(new Date().getFullYear(), 0, 1),
        dateTo: <Date> new Date(),
        stickerType: null,
        selectedCategories: <CategoryListItem[]>[],
        isAllCategoriesSelected: <boolean> false,
        groupByLocations: <boolean> false
    };

    dateFromOptions = {
        formatYear: 'yyyy',
        startingDay: 0
    };

    dateToOptions = {
        formatYear: 'yyyy',
        startingDay: 0,
        minDate: this.model.dateFrom
    };

    constructor(
        public $rootScope: IRetailerRootScope,
        public $state: StateService,
        public $scope: ng.IScope,
        protected $translate: angular.translate.ITranslateService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        protected categoriesSelectorService: CategoriesSelectorService,
        public classificationCategoriesService: ClassificationCategoriesService,
        public nfcRetailerStickersService: NfcRetailerStickersService,
        public notificationService: NotificationService
    ) {
        $scope.$watch('ctrl.model.stickerType', (newValue: any, oldValue: any) => {
            if (newValue !== oldValue) {
                this.isCategoryButtonDisabled = this.model.stickerType && this.model.stickerType.ID !== 1;
            }
        });
    }

    dateFromChange = () => {
        if (moment(this.model.dateFrom).isSameOrAfter(this.model.dateTo, 'day')) {
            this.model.dateTo =  moment(this.model.dateTo).endOf('day').toDate();
            this.model.dateFrom =  moment(this.model.dateTo).startOf('day').toDate();
        }
    }

    dateToChange = () => {
        if (moment(this.model.dateTo).isSameOrBefore(this.model.dateFrom, 'day')) {
            this.model.dateTo =  moment(this.model.dateFrom).endOf('day').toDate();
            this.model.dateFrom =  moment(this.model.dateFrom).startOf('day').toDate();
        }
    }

    close = () => {
        this.modalInstance.close();
    }

    confirm = () => {
        let categoriesIds = this.model.selectedCategories.map(x => x.CategoryID);

        let request: CreateNfcExportRequest = {
            AssignFrom : this.model.dateFrom,
            AssignTo : this.model.dateTo,
            Type : this.model.stickerType && this.model.stickerType.ID !== 0 ? this.model.stickerType.ID : undefined,
            CategoryIDs: this.model.stickerType && this.model.stickerType.ID === 1 ? categoriesIds : [],
            GroupByStores: this.model.groupByLocations
        };

        this.nfcRetailerStickersService.exportCSV(request)
            .then(response => {
                this.notificationService.showSuccessMessage(response);
                this.$state.go('app.nfcs.history', {}, {reload: true});
                this.modalInstance.close();
            })
            .catch(error => this.notificationService.showErrorMessage(error));
    }

    selectCategory = async () => {
        let operationResult: any;
        try {
            operationResult = await this.$uibModal.open({
                component: 'selectProductCategory',
                resolve: {
                    options: (): IChoiceClassificationCategoriesOptions => {
                        return {
                            singleSelect: false,
                            selectedCategories: this.model.selectedCategories,
                            businessType: this.$rootScope.enums.BusinessType.All,
                            isOnlyStoreCategories: false,
                            needAllSelect: true,
                            isAllSelected: this.model.isAllCategoriesSelected,
                            getCategoriesTree: async () => {
                                return await this.nfcRetailerStickersService.getClassificationCategoriesForRetailer();
                            }
                        };
                    }
                },
                size: 'lg',
            }).result;
        } catch (error) {
            return;
        }

        if (operationResult.status === 'ok') {
            if (operationResult.isAllSelected) {
                this.model.isAllCategoriesSelected = true;
            } else {
                this.model.isAllCategoriesSelected = false;
                this.model.selectedCategories = operationResult.selectedCategories;
            }
        }
    }

}

angular.module('naut').component('nfcExport', {
    template: require('./nfc-export.component.html'),
    controller: NfcExport,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/export/nfc-export.component.ts